export default {
  namespaced: true,
  state: {
    visibleCard: 0,
    filter: "all",
    products: [
      {
        id: 3,
        imgsrc: require("@/assets/ballast-5-20.png"),
        imgsrc2: require("@/assets/s5-20.png"),
        title: "Щебень 5х20",
        price: "2000 тг",
        descr:
          "Размер зерен щебня данной фракции колеблется от 5 до 20 мм. Такой размер обеспечивает отличное сцепление в смесях, и делает бетонный состав очень крепким. Щебень 5-20 используется при укладке дорог и производстве бетона и железобетона. Щебень 5-20 по доступным ценам от производителя.",
        type: "1-класс ГОСТ 8267-93",
        category: "stone",
        categoryName: "Щебень",
        categoryDescr:
          "Мы являемся непосредствнными производителями щебня, наша компания является владельцем собственного гранитного карьера.",
      },
      {
        id: 1,
        imgsrc: require("@/assets/ballast-20-40.png"),
        imgsrc2: require("@/assets/s20-40.png"),
        title: "Щебень 20х40",
        price: "1800 тг",
        descr:
          "Используется при возведении всевозможных конструкций из железобетона и прочих зданий производственного назначения, а так же незаменим при сооружении насыпей железнодорожных полотен, путей для трамвайного транспорта и автомобильных дорог.",
        type: "1-класс ГОСТ 8267-93",
        category: "stone",
        categoryName: "Щебень",
        categoryDescr:
          "Мы являемся непосредствнными производителями щебня, наша компания является владельцем собственного гранитного карьера.",
      },
      {
        id: 2,
        imgsrc: require("@/assets/ballast-40-70.png"),
        imgsrc2: require("@/assets/s40-70.png"),
        title: "Щебень 40х70",
        price: "1550 тг",
        descr:
          "Используется для засыпки рыхлых поверхностей и для подготовки полотна для строительства автомобильных дорог и др. асфальтобетонных покрытий.",
        type: "1-класс ГОСТ 8267-93",
        category: "stone",
        categoryName: "Щебень",
        categoryDescr:
          "Мы являемся непосредствнными производителями щебня, наша компания является владельцем собственного гранитного карьера.",
      },
      {
        id: 4,
        imgsrc: require("@/assets/pgs-0-10.png"),
        imgsrc2: require("@/assets/o0-5.jpg"),
        title: "Отсев 0-5",
        price: "1000 тг",
        descr:
          "Отсев рядовой фракция 0-5 мм – самый мелкий подвид в семействе щебней. Добывается методом просеивания сквозь промышленное сито. Является эффективным средством для покрытия оледенелых тротуаров и дорог. Отсев используют также при производстве ФЭМ-плитки, тротуарных покрытий, в ландшафтном дизайне для засыпки клумб.",
        type: "1-класс ГОСТ 8267-93",
        category: "sand",
        categoryName: "Отсев",
        categoryDescr: "",
      },
      {
        id: 5,
        imgsrc: require("@/assets/pgs-0-10.png"),
        imgsrc2: require("@/assets/o0-10.jpg"),
        title: "Отсев 0-10",
        price: "1000 тг",
        descr:
          "Широко используется в сфере дорожного строительства и прокладки железнодорожных магистралей.",
        type: "1-класс ГОСТ 8267-93",
        category: "sand",
        categoryName: "Отсев",
        categoryDescr: "",
      },
    ],
  },
  getters: {
    visibleCard(state) {
      return state.visibleCard;
    },
    filter(state) {
      return state.filter;
    },
    filteredProducts(state) {
      if (state.filter !== "all") {
        return state.products.filter(item => item.category === state.filter);
      } else {
        return state.products;
      }
    },
  },
  mutations: {
    setVisibleCard(state, payload) {
      state.visibleCard = payload;
    },
    setFilter(state, payload) {
      state.filter = payload;
    },
  },
  actions: {
    setVisibleCard(store, payload) {
      store.commit("setVisibleCard", payload);
    },
    setFilter(store, payload) {
      store.commit("setFilter", payload);
    },
  },
};
